import * as Utils from 'Assets/Utils'

import ClientHttpRequest from 'Api/ClientHttpRequest'
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({}).set('Get', new Immutable.List([])).set('Search', new Immutable.List([]))

/* Types */
export const ACTION_GET_DONATIONS_DETAIL = "ACTION_GET_DONATIONS_DETAIL"
export const ACTION_GET_YEAR_GRANTEE = "ACTION_GET_YEAR_GRANTEE"

/* Reducer */
export default (state = initialState, action) => {

    switch (action.type) {
        case ACTION_GET_DONATIONS_DETAIL:
            return state.set('Get', new Immutable.List(action.Obj))
        case ACTION_GET_YEAR_GRANTEE:
            return state.set('Search', new Immutable.List(action.Obj))
        default:
            return state
    }

}

/* Action Creators */
export const getDonationDetail = (id) => {

    return (dispatch) => {
        dispatch(isLoading(true))

        return new ClientHttpRequest({
            service: 'api/DonationsDetail/getDonationDetail',
            method: 'POST',
            data: { id },
            headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
        }).request().then(response => {
            dispatch(isLoading(false))
            dispatch({ type: ACTION_GET_DONATIONS_DETAIL, Obj: response.data })
        }).catch(error => {
            dispatch(isLoading(false))
            dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
            throw error
        })
    }
}

export const getYearGrantee = (id) => {

    return (dispatch) => {
        dispatch(isLoading(true))

        return new ClientHttpRequest({
            service: 'api/DonationsDetail/getYearGrantee',
            method: 'POST',
            data: { id },
            headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
        }).request().then(response => {
            dispatch(isLoading(false))
            dispatch({ type: ACTION_GET_YEAR_GRANTEE, Obj: response.data })
        }).catch(error => {
            dispatch(isLoading(false))
            dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
            throw error
        })
    }
}

export const setDonationDetail = (form) => {

    let temp = {
        deleted: false,
        idDetalleDonacion: form.idDetalleDonacion || null,
        donataria: {
            idDonataria: form.donataria
        },
        anio: form.anio,
        corrida: {
            corridaId: form.corrida
        },
        bien: {
            id: form.bien
        },
        cantidad: form.cantidad,
        municipioDelegacion: {
            id: form.municipio,
            estado: {
                id: form.estado
            }
        },
        montoRepresenta: form.monto
    }

    return (dispatch) => {
        dispatch(isLoading(true))

        return new ClientHttpRequest({
            service: form.idDetalleDonacion ? 'api/DonationsDetail/updateDonationDetail' : 'api/DonationsDetail/setDonationDetail',
            method: 'POST',
            data: { ...temp },
            headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
        }).request().then(response => {
            dispatch(isLoading(false))
            return response.data
        }).catch(error => {
            dispatch(isLoading(false))
            dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
            throw error
        })
    }
}

export const deleteDonationDetail = (idDetalleDonacion) => {

    return (dispatch) => {
        dispatch(isLoading(true))

        return new ClientHttpRequest({
            service: 'api/DonationsDetail/deleteDonationDetail',
            method: 'POST',
            data: {idDetalleDonacion},
            headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
        }).request().then(response => {
            dispatch(isLoading(false))
            return response.data
        }).catch(error => {
            dispatch(isLoading(false))
            dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
            throw error
        })
    }
}

export const clearData = () => {

    return (dispatch) => {
        dispatch({ type: ACTION_GET_YEAR_GRANTEE, Obj: [] })
    }
}



// WEBPACK FOOTER //
// ./src/modules/DonationsDetail/DonationsDetail.js